import { call, put } from 'redux-saga/effects';
import { 
    requestGetTemplates, 
    requestGetGroupTemplate, 
    requestGetProjectTemplate, 
    requestGetTaskTemplate,
    requestGetChecklistTemplate,
    requestCreateChecklistTemplate,
    requestUpdateChecklistTemplate,
    requestDeleteChecklistTemplate,
    requestGetQuoteTemplate,
    requestCreateQuoteTemplate,
    requestUpdateQuoteTemplate,
    requestDeleteQuoteTemplate,
    requestCreateQuoteTemplateFromQuote,
    requestCreateGroupTemplate,
    requestCreateProjectTemplate,
    requestCreateTaskTemplate,
    requestUpdateGroupTemplate,
    requestUpdateProjectTemplate,
    requestUpdateTaskTemplate,
    requestDeleteGroupTemplate,
    requestDeleteProjectTemplate,
    requestDeleteTaskTemplate,
    requestExecuteGroupTemplate,
    requestExecuteProjectTemplate,
    requestGetTemplateImportSource,
    requestImportTemplate
} from '../requests/template';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetTemplates(action) {
    const { callback } = action.payload;
    try {
        const { type, start, limit } = action.payload;
        const response = yield call(requestGetTemplates, type, start, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleGetGroupTemplate(action) {
    try {
        const { templateId, callback } = action.payload;
        const response = yield call(requestGetGroupTemplate, templateId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetProjectTemplate(action) {
    try {
        const { templateId, callback } = action.payload;
        const response = yield call(requestGetProjectTemplate, templateId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetTaskTemplate(action) {
    try {
        const { templateId, callback } = action.payload;
        const response = yield call(requestGetTaskTemplate, templateId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetChecklistTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateId } = action.payload;
        const response = yield call(requestGetChecklistTemplate, templateId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleCreateChecklistTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateData } = action.payload;
        const response = yield call(requestCreateChecklistTemplate, templateData);
        yield put(showAlert({ severity: "success", message: "Checklist template created successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleUpdateChecklistTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateId, templateData } = action.payload;
        const response = yield call(requestUpdateChecklistTemplate, templateId, templateData);
        yield put(showAlert({ severity: "success", message: "Checklist template updated successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleDeleteChecklistTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateId } = action.payload;
        yield call(requestDeleteChecklistTemplate, templateId);
        yield put(showAlert({ severity: "success", message: "Checklist template deleted successfully" }));
        if (callback) {
            callback(true);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleGetQuoteTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateId } = action.payload;
        const response = yield call(requestGetQuoteTemplate, templateId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleCreateQuoteTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateData } = action.payload;
        const response = yield call(requestCreateQuoteTemplate, templateData);
        yield put(showAlert({ severity: "success", message: "Quote template created successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleUpdateQuoteTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateId, templateData } = action.payload;
        const response = yield call(requestUpdateQuoteTemplate, templateId, templateData);
        yield put(showAlert({ severity: "success", message: "Quote template updated successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleDeleteQuoteTemplate(action) {
    const { callback } = action.payload;
    try {
        const { templateId } = action.payload;
        yield call(requestDeleteQuoteTemplate, templateId);
        yield put(showAlert({ severity: "success", message: "Quote template deleted successfully" }));
        if (callback) {
            callback(true);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleCreateQuoteTemplateFromQuote(action) {
    const { callback } = action.payload;
    try {
        const { quoteId, data } = action.payload;
        const response = yield call(requestCreateQuoteTemplateFromQuote, quoteId, data);
        yield put(showAlert({ severity: "success", message: "Quote template created successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleCreateGroupTemplate(action) {
    try {
        const { templateData, callback } = action.payload;
        const response = yield call(requestCreateGroupTemplate, templateData);
        yield put(showAlert({ severity: "success", message: "GroupTemplate created successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleCreateProjectTemplate(action) {
    try {
        const { templateData, callback } = action.payload;
        const response = yield call(requestCreateProjectTemplate, templateData);
        yield put(showAlert({ severity: "success", message: "ProjectTemplate created successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleCreateTaskTemplate(action) {
    try {
        const { templateData, callback } = action.payload;
        const response = yield call(requestCreateTaskTemplate, templateData);
        yield put(showAlert({ severity: "success", message: "TaskTemplate created successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateGroupTemplate(action) {
    try {
        const { templateId, templateData, callback } = action.payload;
        const response = yield call(requestUpdateGroupTemplate, templateId, templateData);
        yield put(showAlert({ severity: "success", message: "GroupTemplate updated successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateProjectTemplate(action) {
    try {
        const { templateId, templateData, callback } = action.payload;
        const response = yield call(requestUpdateProjectTemplate, templateId, templateData);
        yield put(showAlert({ severity: "success", message: "ProjectTemplate updated successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateTaskTemplate(action) {
    try {
        const { templateId, templateData, callback } = action.payload;
        const response = yield call(requestUpdateTaskTemplate, templateId, templateData);
        yield put(showAlert({ severity: "success", message: "TaskTemplate updated successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteGroupTemplate(action) {
    try {
        const { templateId, callback } = action.payload;
        yield call(requestDeleteGroupTemplate, templateId);
        yield put(showAlert({ severity: "success", message: "GroupTemplate deleted successfully" }));
        if (callback) {
            callback();
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteProjectTemplate(action) {
    try {
        const { templateId, callback } = action.payload;
        yield call(requestDeleteProjectTemplate, templateId);
        yield put(showAlert({ severity: "success", message: "ProjectTemplate deleted successfully" }));
        if (callback) {
            callback();
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteTaskTemplate(action) {
    try {
        const { templateId, callback } = action.payload;
        yield call(requestDeleteTaskTemplate, templateId);
        yield put(showAlert({ severity: "success", message: "TaskTemplate deleted successfully" }));
        if (callback) {
            callback();
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleExecuteGroupTemplate(action) {
    try {
        const { templateId, options, callback } = action.payload;
        const response = yield call(requestExecuteGroupTemplate, templateId, options);
        yield put(showAlert({ severity: "success", message: "Template executed successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
    }
}

export function* handleExecuteProjectTemplate(action) {
    try {
        const { templateId, options, callback } = action.payload;
        const response = yield call(requestExecuteProjectTemplate, templateId, options);
        yield put(showAlert({ severity: "success", message: "Template executed successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
    }
}

export function* handleGetTemplateImportSource(action) {
    const { callback } = action.payload;
    try {
        const { sourceType, sourceId } = action.payload;
        const response = yield call(requestGetTemplateImportSource, sourceType, sourceId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleImportTemplate(action) {
    const { callback } = action.payload;
    try {
        const { sourceType, sourceId, template, importChildren } = action.payload;
        const response = yield call(requestImportTemplate, { sourceType, sourceId, template, importChildren });
        yield put(showAlert({ severity: "success", message: "Template imported successfully" }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}
